import { Component } from '@angular/core';
import { ReportsService } from '../../services/reports.service';
import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent {

  constructor(private graphqlService: ReportsService, private utilsService: UtilsService) {}

  attractionReport() {
    this.graphqlService.attractionReport().subscribe(res => {
      if (res.data.attractionReport.success) {
        this.utilsService.openSnackBar('You will receive the attraction report shortly on the email!', '');
      }
    });
  }

  locationReport() {
    this.graphqlService.locationReport().subscribe(res => {
      if (res.data.locationReport.success) {
        this.utilsService.openSnackBar('You will receive the location report shortly on the email!', '');
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/reports/reports.component.ts